import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const SEO = ({ title, description, keywords }) => {
  const { t } = useTranslation();
  
  // Get keywords as array or use default empty array
  const keywordsArray = keywords || 
    (t('seo.defaultKeywords', { returnObjects: true }) || []);

  return (
    <Helmet>
      <title>{title || t('seo.defaultTitle')}</title>
      <meta 
        name="description" 
        content={description || t('seo.defaultDescription')} 
      />
      <meta 
        name="keywords" 
        content={Array.isArray(keywordsArray) ? keywordsArray.join(', ') : keywordsArray} 
      />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title || t('seo.defaultTitle')} />
      <meta 
        property="og:description" 
        content={description || t('seo.defaultDescription')} 
      />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={title || t('seo.defaultTitle')} />
      <meta 
        property="twitter:description" 
        content={description || t('seo.defaultDescription')} 
      />
    </Helmet>
  );
};

export default SEO;